import React, { ChangeEvent } from "react";
import {
  Theme,
  createStyles,
  WithStyles,
  withStyles,
  Typography,
  Grid,
  Button,
  TextField,
} from "@material-ui/core";
import _ from "lodash";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import { onlyAllowNumbers } from "../../../../utils";
import CustomInfoIcon from "../../../common/CustomInfoIcon";
import { QUESTION_TYPES } from "../../../../constants/comman";
import {
  SectionFocusedContext,
  SectionFocusedContextValue,
} from "../../../common/MyPATBaseSection";
import AddFeedback from "../../../content-request/components/AddFeedback";

const styles = (theme: Theme) =>
  createStyles({
    borderBox: {
      background: "#FFFFFF",
      border: "1px solid #E1E1E1",
      boxSizing: "border-box",
      borderRadius: 5,
      // padding: theme.spacing.unit,
      padding: 14,
      marginBottom: "14px",
    },
    OptionHeading: {
      marginBottom: 14,
      fontSize: "16px",
      lineHeight: "22px",
      color: "#333",
    },
    optionContainer: {
      // marginTop: '18px',
      margin: "0 0 0px 2px",
    },
    optionContainerTxt: {
      margin: "0 0 14px 0px",
    },
    headingTxt: {
      fontSize: "15px",
      color: "#333",
    },
    infoIcon: {
      "&:nth-child(1)": {
        "& img": {
          verticalAlign: "baseline",
          "&:hover": {
            "& tooltipDetails": {
              display: "none",
            },
          },
        },
      },
    },
    optionLabel: {
      fontSize: 15,
      color: "#666",
    },
    optionSettingText: {
      width: "70px",
      margin: "0px 0 0 10px",
      textAlign: "center",
      "& input": {
        padding: "10px",
        textAlign: "center",
      },
      "& input[type=number]::-webkit-inner-spin-button, & input[type='number'].mod::-moz-inner-spin-button, & input[type=number]::-webkit-outer-spin-button, & input[type='number'].mod::-moz-outer-spin-button": {
        opacity: 0,
      },
      "& input[type=number]:hover::-webkit-inner-spin-button": {
        "-moz-appearance": "textfield",
        appearance: "none",
      },
      "& input[type=number]::-webkit-inner-spin-button": {
        "-moz-appearance": "textfield",
        appearance: "none",
      },
    },

    dialogHeading: {
      fontSize: "16px",
      lineHeight: "22px",
      color: "#333",
      display: "block",
      // fontWeight: 600,
    },
    Note: {
      fontSize: "14px",
      lineHeight: "22px",
      color: "#333",
      fontWeight: 600,
    },
    dialogSubheading: {
      fontSize: "14px",
      lineHeight: "22px",
      color: "#666",
    },
    blueColor: {
      color: "#1D7DEA",
    },
    feedbackContainer: {
      position: "relative",
      "& .feedbackBlock": {
        top: -16,
        left: "100%",
        position: "absolute",
        marginLeft: 20,
        zIndex: 2,
      },
    },
    feedbackHighlight: {
      cursor: "pointer",
      "&:hover": {
        color: "#1d7dea",
      },
    },
  });

interface Props {
  classes: any;
  handleOptionSettingsChange: any;
  optionSettings: any;
  subType: string;
  tag: string;
  openFeedback: boolean;
  addFeedback: Function;
  replyFeedback: Function;
  closeFeedback: Function;
  resolveFeedback: Function;
  clickedfeedbackData: any;
  addNewFeedback: Function;
  questionIndex?: number;
  selectedIndex: number;
  questionId?: string;
  authorType?: string;
}
function checkForFeedback(props: Props) {
  let { clickedfeedbackData, questionId } = props;
  if (props.selectedIndex !== undefined) {
    return (
      (_.isEmpty(clickedfeedbackData) &&
        props.openFeedback &&
        props.tag === "optionSettings" &&
        props.selectedIndex === props.questionIndex) ||
      (!_.isEmpty(clickedfeedbackData) &&
        props.openFeedback &&
        clickedfeedbackData.tag === "optionSettings" &&
        questionId === clickedfeedbackData.contentId)
    );
  } else {
    return props.openFeedback && props.tag === "optionSettings";
  }
}

function OptionSettings(props: Props) {
  const {
    classes,
    handleOptionSettingsChange,
    optionSettings,
    subType,
    questionIndex,
    authorType
  } = props;
  if (subType === QUESTION_TYPES.TRUE_FALSE.toString()) {
    return null;
  }

  return (
    <SectionFocusedContext.Consumer>
      {({ setSectionFocus, focusedBorder }: SectionFocusedContextValue) => (
        <div>
          <Grid container alignItems="center">
            <Typography
              className={classes.OptionHeading}
              onClick={() =>
                props.addFeedback("optionSettings", questionIndex)
              }
            >
              <span
                id={checkForFeedback(props) ? "feedbackScroll" : ""}
                className={`${classes.feedbackContainer} ${
                  checkForFeedback(props) ? classes.blueColor : ""
                } ${props.openFeedback ? classes.feedbackHighlight : ""}`}
              >
                {/* Option Settings */}
                {checkForFeedback(props) && (
                  <Grid className="feedbackBlock">
                    <AddFeedback
                      replyFeedback={props.replyFeedback}
                      closeFeedback={props.closeFeedback}
                      resolveFeedback={props.resolveFeedback}
                      clickedfeedbackData={props.clickedfeedbackData}
                      addNewFeedback={props.addNewFeedback}
                      author={props.authorType}
                    />
                  </Grid>
                )}
              </span>
            </Typography>
          </Grid>

          <Grid
            container
            className={classes.optionContainerTxt}
            alignItems="center"
          >
            <Grid item xs={6}>
              <Grid container alignItems="center">
                <Grid item>
                  <Typography className={classes.headingTxt}>
                    Total options to be shown to the students :
                  </Typography>
                </Grid>

                <Grid item>
                  <TextField
                    variant="outlined"
                    disabled={false}
                    classes={{ root: classes.optionSettingText }}
                    type="number"
                    name="displayCount"
                    required
                    onFocus={() => setSectionFocus(true)}
                    onBlur={() => setSectionFocus(false)}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      let value: string | number = e.target.value;
                      if (value) {
                        value = parseInt(value) > 0 ? parseInt(value) : 1;
                        value =
                          value > 26 ? optionSettings.displayCount : value;
                      }
                      handleOptionSettingsChange("displayCount", value);
                    }}
                    onKeyPress={onlyAllowNumbers}
                    value={optionSettings.displayCount}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={6} style={{ display: 'none' }} >
              <Grid container justify="flex-end">
                <RadioGroup
                  name="shuffleType"
                  onChange={(_: any, value: string) =>
                    handleOptionSettingsChange("shuffleType", value)
                  }
                >
                  <Grid container className={classes.optionContainer} justify="flex-end">
                    <Grid item lg={6}>
                      <FormControlLabel
                        value="same"
                        checked={optionSettings.shuffleType === "same"}
                        control={
                          <Radio
                            color="primary"
                            onFocus={() => setSectionFocus(true)}
                            onBlur={() => setSectionFocus(false)}
                          />
                        }
                        label={
                          <Typography className={classes.optionLabel}>
                            Same Sequence{" "}
                            <span className={classes.infoIcon}>
                              <CustomInfoIcon
                                infoDialogContentType="Add alternate answer"
                                isInfoIcon={true}
                                isRightArrow={false}
                                isCenterArrow={true}
                                toolTipDirection="top"
                                knowMoreAbout={false}
                                details="Click to know more"
                                dialogTitle="Same Sequence"
                                imageURL="/assets/svg/myLibrary/same-sequence.svg"
                                dialogPara={
                                  <Typography>
                                    <span className={classes.dialogHeading}>
                                      All the options listed will appear to
                                      the student in the same sequence as
                                      defined.
                                    </span>
                                    <b className={classes.Note}>Note: </b>
                                    <span
                                      className={classes.dialogSubheading}
                                    >
                                      If the same sequence is selected, total
                                      options will appear in a sequence along
                                      with the correct option.
                                    </span>
                                  </Typography>
                                }
                              />
                            </span>
                          </Typography>
                        }
                      />
                    </Grid>
                    <Grid item lg={6}>
                      <FormControlLabel
                        value="random"
                        checked={optionSettings.shuffleType === "random"}
                        control={
                          <Radio
                            color="primary"
                            onFocus={() => setSectionFocus(true)}
                            onBlur={() => setSectionFocus(false)}
                          />
                        }
                        label={
                          <Typography className={classes.optionLabel}>
                            Random Shuffle{" "}
                            <span className={classes.infoIcon}>
                              <CustomInfoIcon
                                infoDialogContentType="Add alternate answer"
                                isInfoIcon={true}
                                isRightArrow={false}
                                isCenterArrow={true}
                                toolTipDirection="top"
                                knowMoreAbout={false}
                                details="Click to know more"
                                dialogTitle="Random Shuffle"
                                imageURL="/assets/svg/myLibrary/random-shuffle.svg"
                                dialogPara={
                                  <Typography>
                                    <span className={classes.dialogHeading}>
                                      Options will be shown to the student
                                      randomly from the list of available
                                      options.
                                    </span>{" "}
                                    <b className={classes.Note}>Note: </b>
                                    <span
                                      className={classes.dialogSubheading}
                                    >
                                      {" "}
                                      You can define any number of options in
                                      this case.
                                    </span>
                                  </Typography>
                                }
                              />
                            </span>
                          </Typography>
                        }
                      />
                    </Grid>
                  </Grid>
                </RadioGroup>
              </Grid>
            </Grid>
            {/* <Grid item>
              <TextField
                variant="outlined"
                disabled={false}
                classes={{ root: classes.optionSettingText }}
                type="number"
                name="displayCount"
                required
                onFocus={() => setSectionFocus(true)}
                onBlur={() => setSectionFocus(false)}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  let value: string | number = e.target.value;
                  if (value) {
                    value = parseInt(value) > 0 ? parseInt(value) : 1;
                    value = value > 26 ? optionSettings.displayCount : value;
                  }
                  handleOptionSettingsChange("displayCount", value);
                }}
                onKeyPress={onlyAllowNumbers}
                value={optionSettings.displayCount}
              />
            </Grid> */}
          </Grid>

          {/* <Grid container>
            <RadioGroup
              name="shuffleType"
              onChange={(_: any, value: string) =>
                handleOptionSettingsChange("shuffleType", value)
              }
            >
              <Grid container className={classes.optionContainer}>
                <Grid item lg={6}>
                  <FormControlLabel
                    value="same"
                    checked={optionSettings.shuffleType === "same"}
                    control={
                      <Radio
                        color="primary"
                        onFocus={() => setSectionFocus(true)}
                        onBlur={() => setSectionFocus(false)}
                      />
                    }
                    label={
                      <Typography className={classes.optionLabel}>
                        Same Sequence{" "}
                        <span className={classes.infoIcon}>
                          <CustomInfoIcon
                            infoDialogContentType="Add alternate answer"
                            isInfoIcon={true}
                            isRightArrow={false}
                            isCenterArrow={true}
                            toolTipDirection="top"
                            knowMoreAbout={false}
                            details="Click to know more"
                            dialogTitle="Same Sequence"
                            imageURL="/assets/svg/myLibrary/same-sequence.svg"
                            dialogPara={
                              <Typography>
                                <span className={classes.dialogHeading}>
                                  All the options listed will appear to the
                                  student in the same sequence as defined.
                                </span>
                                <b className={classes.Note}>Note: </b>
                                <span className={classes.dialogSubheading}>
                                  If the same sequence is selected, total
                                  options will appear in a sequence along with
                                  the correct option.
                                </span>
                              </Typography>
                            }
                          />
                        </span>
                      </Typography>
                    }
                  />
                </Grid>
                <Grid item lg={6}>
                  <FormControlLabel
                    value="random"
                    checked={optionSettings.shuffleType === "random"}
                    control={
                      <Radio
                        color="primary"
                        onFocus={() => setSectionFocus(true)}
                        onBlur={() => setSectionFocus(false)}
                      />
                    }
                    label={
                      <Typography className={classes.optionLabel}>
                        Random Shuffle{" "}
                        <span className={classes.infoIcon}>
                          <CustomInfoIcon
                            infoDialogContentType="Add alternate answer"
                            isInfoIcon={true}
                            isRightArrow={false}
                            isCenterArrow={true}
                            toolTipDirection="top"
                            knowMoreAbout={false}
                            details="Click to know more"
                            dialogTitle="Random Shuffle"
                            imageURL="/assets/svg/myLibrary/random-shuffle.svg"
                            dialogPara={
                              <Typography>
                                <span className={classes.dialogHeading}>
                                  Options will be shown to the student randomly
                                  from the list of available options.
                                </span>{" "}
                                <b className={classes.Note}>Note: </b>
                                <span className={classes.dialogSubheading}>
                                  {" "}
                                  You can define any number of options in this
                                  case.
                                </span>
                              </Typography>
                            }
                          />
                        </span>
                      </Typography>
                    }
                  />
                </Grid>
              </Grid>
            </RadioGroup>
          </Grid> */}
        </div>
      )}
    </SectionFocusedContext.Consumer>
  );
}

// @ts-ignore
export default withStyles(styles)(OptionSettings);
